import {
	AddEmployeesContainer,
	SpecificEmployeeContainer,
	AddBulkEmployeesContainer,
	TerminateBulkEmployeesContainer,
	ViewGroupsContainer,
	AddLoanContainer,
	UpdateBulkEmployeesSalaryContainer,
	UploadCommissionSheetContainer,
	ApproveCommissionPaymentContainer,
	CommisionTableContainer,
} from '../../containers';
import {
	AppPage,
	PageLoader,
	BusinessInsightComponent as BIC,
	Searchbar,
	MimaDropdownFilter,
	MimaFilter,
	MimaDataTable,
	MimaTable,
} from '../../components';
import ViewDepartmentsContainer from '../../containers/EmployeesContainer/ViewDepartmentsContainer';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { downloadFormatDate, downloadXlsx2 } from '../../utils/download';
import { AnimatePresence } from 'framer-motion';
import { employeeStore, userStore } from '../../stores';
import React, { useMemo, useState } from 'react';
import { Formik } from 'formik';
import moment from 'moment';
import Survey from '../../components/Survey/Survey';
import constant from '../../utils/constant';

const Employees = ({
	addEmployees,
	loading,
	refresh,
	employeesList,
	closeModal,
	validationSchema,
	onSubmit,
	loan,
	employeeNav,
	specificEmployee,
	bulkEmployeesSalary,
	uploadCommissionSheet,
	approveCommissionPayment,
	goToSpecificEmployee,
	deptModal,
	addBulkEmployees,
	terminateEmployees,
	groupModal,
	resetFilter,
	loanModal,
	handleOptionSelect,
	isLoading,
	employeesdata,
	isFetching,
	limit,
	onLimitChange,
	currentPage,
	setCurrentPage,
	setSearchQuery,
}) => {
	// const isBelow800 = useMediaQuery({
	// 	query: '(max-width: 800px)',
	// });

	const [filteredEmployees, setFilteredEmployees] = useState([]);
	const [onReset, setOnReset] = useState(false);
	const [tableType, setTableType] = useState('Employees');
	const [showSurvey, setShowSurvey] = useState(false);

	const tableData = useMemo(() => {
		if (employeesdata?.status === constant.Success) {
			return employeesdata?.data?.employees || [];
		}
		return [];
	}, [employeesdata]);

	const tableColumns = [
		{
			Header: 'Name',
			accessor: 'name',
			Cell: ({ cell }) => {
				const firstname = cell.row.original?.user?.firstname;
				const lastname = cell.row.original?.user?.lastname;
				return <span>{`${firstname}-${lastname}`}</span>;
			},
		},
		{
			Header: 'Phone Number',
			Cell: ({ cell }) => {
				const mobile = cell.row.original?.user?.mobile;

				return <span>{mobile}</span>;
			},
		},
		{
			Header: 'Job Role',
			Cell: ({ cell }) => {
				const jobTitle = cell.row.original?.jobTitle;

				return <span>{jobTitle}</span>;
			},
		},

		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const item = cell.row.original;
				return (
					<span
						className="action-text"
						onClick={() => {
							goToSpecificEmployee(item);
						}}>
						{' '}
						View More{' '}
					</span>
				);
			},
		},
	];

	const printData = tableData.map(employee => ({
		Name: `${employee.user?.firstname} ${employee?.user?.middlename || ''} ${
			employee.user?.lastname
		}`,
		'Phone Number': employee?.user?.mobile,
		Gender: employee?.user?.gender,
		Email: employee?.user?.email,
		'Start Date': employee.startDate
			? moment(employee.startDate).format('DD-MM-YYYY hh:mm')
			: 'Not Set',
		'Employment Type': employee.employmentType,
		'Job Title': employee.jobTitle,
		Department: employee.department?.name,
		'Gross Pay': employee?.grossPay?.toFixed(2) || 0,
		'Net Pay': employee?.netPay?.toFixed(2) || 0,
		'Paye Tax': employee?.tax?.toFixed(2) || 0,
		Pension: employee?.pension?.toFixed(2),
		NHF: employee?.nhf?.toFixed(2) || 0,
		WHT: employee?.wht?.toFixed(2) || 0,
		Bank: employee.withdrawalBankAccount?.bank,
		'Account Name': employee.withdrawalBankAccount?.accountName,
		'Account Number': employee.withdrawalBankAccount?.accountNumber,
	}));

	const printUpdateEmployeeSalaryData = [];
	for (let index = 0; index < tableData.length; index++) {
		const employee = tableData[index];
		if (employee.status === 'ACTIVE') {
			printUpdateEmployeeSalaryData.push({
				Id: employee._id,
				Name: `${employee.user?.firstname} ${employee?.user?.middlename || ''} ${employee.user?.lastname}`,
				jobTitle: employee.jobTitle,
				employmentType: employee.employmentType,
				grossPay: 0,
			});
		}
	}

	return (
		<AppPage pageTitle="Employees" refresh={refresh}>
			<div className={styles.main}>
				<div className={styles.main__metrics}>
					<BIC
						title="Active Employees"
						amount={
							employeesList?.filter(employee => employee.status === 'ACTIVE')
								?.length || 0
						}
						styleClass={styles.main__metrics_active}
					/>
					<BIC
						title="Suspended Employees"
						amount={
							employeesList?.filter(employee => employee.status === 'SUSPENDED')
								?.length || 0
						}
						styleClass={styles.main__metrics_suspended}
					/>
					<BIC
						title="Terminated Employees"
						amount={
							employeesList?.filter(
								employee => employee.status === 'TERMINATED'
							)?.length || 0
						}
						styleClass={styles.main__metrics_terminated}
					/>
				</div>

				<div className={styles.main_nav}>
					{employeeNav.map((navItem, index) => (
						<div
							key={index}
							onClick={() => {
								if (navItem.title === 'Download Report') {
									downloadXlsx2(
										printData,
										`Employees-${downloadFormatDate(new Date())}`
									);
								} else {
									navItem.clickAction();
								}
							}}
							className={styles.main_nav_item}>
							{navItem.title}
						</div>
					))}
				</div>
				<Formik
					initialValues={{
						status: '',
						department: '',
						employeeGroup: '',
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<MimaFilter
							filterClick={() => {
								setOnReset(false);
								handleSubmit();
							}}
							loading={loading}
							resetClick={() => {
								setOnReset(true);
								resetFilter();
							}}>
							<MimaDropdownFilter
								labelTitle="status"
								name="status"
								value={values.status}
								id="status"
								canSelectAll={true}
								onChange={data => {
									setFieldValue('status', data.key);
								}}
								placeholder={'Status'}
								currentValue={values.status}
								data={[
									{ key: 'ACTIVE', value: 'ACTIVE' },
									{ key: 'SUSPENDED', value: 'SUSPENDED' },
									{ key: 'TERMINATED', value: 'TERMINATED' },
								]}
								touched={touched.status}
							/>
							<MimaDropdownFilter
								labelTitle="Department"
								placeholder="Select"
								canSelectAll={true}
								name="department"
								value={values.department}
								id="department"
								onChange={data => {
									setFieldValue('department', data.key);
								}}
								data={employeeStore.mapDepartments}
								touched={touched.department}
							/>
						</MimaFilter>
					)}
				</Formik>

				<div className={styles.main_nav}>
					<div
						className={
							tableType === 'Employees'
								? styles.main_nav_item_active
								: styles.main_nav_item
						}
						onClick={() => {
							setTableType('Employees');
						}}>
						Employees Table
					</div>
					<div
						className={
							tableType === 'Commissions'
								? styles.main_nav_item_active
								: styles.main_nav_item
						}
						onClick={() => {
							setTableType('Commissions');
						}}>
						Commissions Table
					</div>
				</div>
				{tableType === 'Employees' && (
					<>
						{loading ? (
							<PageLoader
								title="while we fetch your employee Details"
								loading={loading}
							/>
						) : (
							<>
								<MimaTable
									tableData={tableData}
									tableColumns={tableColumns}
									searchPlaceholder="Search Employee"
									searchVariant="wide"
									totalItems={employeesdata?.data?.totalCounts}
									onLimitChange={onLimitChange}
									isLoading={isLoading}
									isFetching={isFetching}
									limit={limit}
									currentPage={currentPage}
									setCurrentPage={setCurrentPage}
									setSearchQuery={setSearchQuery}
								/>
							</>
						)}
					</>
				)}
				{tableType === 'Commissions' && (
					<>
						{loading ? (
							<PageLoader
								title="while we fetch your employee Details"
								loading={loading}
							/>
						) : (
							<>
								<CommisionTableContainer />
							</>
						)}
					</>
				)}
			</div>

			{(addEmployees ||
				specificEmployee ||
				deptModal ||
				loan ||
				addBulkEmployees ||
				terminateEmployees ||
				groupModal ||
				bulkEmployeesSalary ||
				uploadCommissionSheet ||
				approveCommissionPayment ||
				loanModal ||
				showSurvey) && (
				<div className="modal">
					<AnimatePresence>
						{addEmployees && (
							<AddEmployeesContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{specificEmployee && (
							<SpecificEmployeeContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{deptModal && (
							<ViewDepartmentsContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{addBulkEmployees && (
							<AddBulkEmployeesContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{terminateEmployees && (
							<TerminateBulkEmployeesContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{bulkEmployeesSalary && (
							<UpdateBulkEmployeesSalaryContainer
								printUpdateEmployeeSalaryData={printUpdateEmployeeSalaryData}
								closeModal={closeModal}
							/>
						)}
						{uploadCommissionSheet && (
							<UploadCommissionSheetContainer
								printUpdateEmployeeSalaryData={printUpdateEmployeeSalaryData}
								closeModal={closeModal}
							/>
						)}
						{approveCommissionPayment && (
							<ApproveCommissionPaymentContainer closeModal={closeModal} />
						)}
						{groupModal && <ViewGroupsContainer closeModal={closeModal} />}
						{loan && (
							<AddLoanContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{showSurvey && (
							<Survey
								title=""
								reviewId={userStore.reviewId}
								closeModal={() => {
									setShowSurvey(false);
								}}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Employees;
